<app-header [hasHierarchyDropdown]="true" (backAction)="goToHome()"></app-header>
<div class="fd-accreditation-form__container">
  <router-outlet></router-outlet>
</div>
